import { render, staticRenderFns } from "./bannerskipselect.vue?vue&type=template&id=19b8c275&scoped=true&"
import script from "./bannerskipselect.vue?vue&type=script&lang=js&"
export * from "./bannerskipselect.vue?vue&type=script&lang=js&"
import style0 from "./bannerskipselect.vue?vue&type=style&index=0&id=19b8c275&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19b8c275",
  null
  
)

export default component.exports